import { useTranslation } from 'react-i18next';
import { Modal as BootstrapModal } from 'react-bootstrap';
import { Typography } from 'app/components/ui';

import './Modal.scss';

interface ContinuationModalProps {
  show: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ContinuationModal = ({ show, onConfirm, onCancel }: ContinuationModalProps) => {
  const { t } = useTranslation(['common', 'tag']);

  return (
    <BootstrapModal show={show} onHide={onCancel} contentClassName="tags-modal__content tags-modal__content--continuation" centered>
      <button onClick={onCancel} type="button" aria-label="Close" className="tags-modal__close-btn">
        <i className="fa-solid fa-xmark" />
      </button>

      <div className="tags-modal__header">
        <i className="fa-solid fa-tag tags-modal__tag-icon" />

        <div className="tags-modal__title-group">
          <Typography variant="body-7" fontWeight="semibold" color="#1e2533">
            {t('tag:continuation.modal.title')}
          </Typography>

          <Typography variant="body-7" fontWeight="light" color="#616066">
            {t('tag:continuation.modal.message')}
          </Typography>
        </div>
      </div>

      <div className="tags-modal__actions">
        <button className="tags-modal__btn-cancel" onClick={onCancel}>
          {t('common:cancel')}
        </button>
        <button className="tags-modal__btn-confirm" onClick={onConfirm}>
          {t('common:add')}
        </button>
      </div>
    </BootstrapModal>
  );
};
